import './i18n';

import { createRoot } from 'react-dom/client';
import ProcessingBanner from './banner';


const ALLOWLIST = ['https://editor.p5js.org', 'https://foundation-donate-banner.netlify.app/'];

const hostName =  new URL(location.href).hostname;

const matches = (host, domain) => {
  return new URL(domain).hostname === host;
};

const enabled = process.env.NODE_ENV === "development" || ALLOWLIST.some(domain => matches(hostName, domain));

if (enabled) {
  const body = document.querySelector('body')
  const banner = document.querySelector("#processing-banner") || document.createElement('div');
  body.prepend(banner);
  
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://donorbox.org/install-popup-button.js';
  script.id = 'donorbox-popup-button-installer';
  script.defer = true;
  body.appendChild(script);
  
  const style = document.createElement('style');
  style.innerHTML = `
   @media (min-width: 770px) {
      body .top-layout-grid nav{
        position: sticky;
        shape-outside: inset(50%);
        float: left;
    }
  }
  `;
  body.appendChild(style);
  
  const root = createRoot(banner);
  root.render(<ProcessingBanner />);
}
